import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { CreateLeadFooter, StyledSubHeader, StyledGridContainer } from '../../Components/Styled/index';
import { Box, Button, FormControlLabel, Stack, Switch, Tooltip, Typography } from '@mui/material';
import { privateRoutesPath } from '../../Routes';
import { useSnackbar } from 'notistack';
import BiztantuLoader from '../../Components/Loader';
import { useSelector, useDispatch } from 'react-redux';
import { requestShowLoader, requestHideLoader } from '../../Store/Global/action';
import { createRequestData, dateFormatting,dateFormattingForShowing,getEntityColumns, getRequestData, updateRequestData, validateFields } from '../../Utility/apiHelper';
import {ACTIVE_STATUS,CUSTOMER_DOC_TYPE, CUSTOMER_STATUS, fullNameWidth, handleValidateCodevalue, idWidth, LEAD_SOURCE, LEAD_STATUS, LEAD_STATUS_DEAL_CLOSED, sellingPriceWidth, statusWidth, whocolumnWidth, TASK_STATUS, TASK_STATUS_CANCELLED, TASK_STATUS_CLOSED, STATIC_ENTITY_CONFIG, phoneCountryCodes, ADDITIONAL_ATTRIBUTE_FIELDS,CUSTOMIZABLE_FIELDS_CUSTOMER, RECOMMENED_PRODUCTS_FOLLOWUP_NOTE, CHILD_DATAGRIDTABLE_HEIGHT, ROWS_TO_VIEW_IN_CHILD_TABLE, statusChipWidth, searchEntity } from '../../Utility/constant';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import AddressFields from '../../Components/AddressFields';
import { EntityNote } from '../../Components/EntityNote';
import DataGridTable from '../../Components/DataGrid';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import WhoColumnTextfieds from '../../Components/WhoColumnTextfieds';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import CommonComm from '../../Components/CommonComm';
import LeadAccordion from '../../Components/LeadAccordion';
import AuditLogs from '../Configuration/Audit';

import DocumentManagement from '../../Components/DocumentManagement';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import CommonPoc from '../../Components/CommonPoc';
import StatusChip from '../../Components/StatusChip';
import { createFilterOptions } from '@mui/material';
import LeadProduct from '../../Components/LeadProduct';
import SupportChatDialog from '../../Components/SupportChatDialog';
import { requestCreateCustomer, requestGetAllCustomers } from '../../Store/Customer/action';
import moment from 'moment';
import { formatAdditionalAttributesForPayload } from '../../Utility/payloadFormatter';
import CustomizableFields from '../../Components/CustomizableFields';
import { requestGetAllActiveProducts } from '../../Store/Product/action';
import useNavigation from '../../Utility/hooks/useNavigation';
import ActionableDetailCard from '../../Components/ActionableDetailCard';
import { useAccordionData } from '../../Utility/hooks/useAccordionData';
import './Customer.css';

const CreateMerchant = (props) => {
    const customerid = props.match.params.id;
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isDemoMode = searchParams.get('demo') === 'true';
    const [customerDetail, setCustomerdetails] = useState(
        {
            ...phoneCountryCodes,
            status : 'CUSTOMER_STATUS_ACTIVE',
            state : "Other",
            invoiceDtoList : [],
            leadDtoList : [],
            salesOrderDtoList : []
        }
    )
    
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const canEdit = !!specificRolePermission?.isCustomerManage;
    const [isEntityLocked, setIsEntityLocked] = useState(false);
    const isViewMode = !canEdit || isEntityLocked;
    // Audit Logs accordion — controlled via useAccordionData; fetches lazily on expand
    const auditAccordion = useAccordionData(null, { refetchOnEveryOpen: true, unmountOnExit: true });
    const setIsAuditAccordionExpanded = auditAccordion.setIsExpanded;

    const [initialCustomerDetails , setInitialCustomerDetails] = useState(null)
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [requiredValue, setRequiredValue] = useState(false);
    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const customerSourceData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == LEAD_SOURCE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const customerStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == CUSTOMER_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const ownerlist = useSelector(state => state?.owner?.ownerlist);
    const docType = useSelector(state=> state?.lookup?.lookupData)?.find((item) => item?.name == CUSTOMER_DOC_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);        
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);

    const customerTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "CUSTOMER");
        const sourceData = Object.keys(data).length > 0 ? data: STATIC_ENTITY_CONFIG?.CUSTOMER;

            const { customerId, ...rest } = sourceData;
         return rest;
    }, [allEntityData,customerid]);
    const leadStatusData = useSelector(state => state?.lookup?.lookupData)
    ?.find((item) => item?.name == LEAD_STATUS)?.codes
    ?.filter(item => item?.status == ACTIVE_STATUS)
    ?.sort((a,b) => a?.sequence - b?.sequence);


const [showOpenLeadsOnly, setShowOpenLeadsOnly] = useState(true);
    const [isOpenSupportChatDialog, setIsOpenSupportChatDialog] = useState(false);
const activeProducts = useSelector(state => state?.product?.activeProducts);
const { navigateTo, goBackTo,openInNewTab } = useNavigation();
useEffect(() => {
        dispatch(
            requestGetAllActiveProducts({
                params: {
                    status: "PRODUCT_STATUS_ACTIVE"
                }
            })
        );
}, [dispatch]);

const handleToggleOpenLeads = useCallback((event) => {
    setShowOpenLeadsOnly(event.target.checked);
}, []);
    var filterdOptionlist = [];
        const handleViewOrderSlip = (id , value) =>() => {

        navigateTo(
            `${privateRoutesPath.VIEW_ORDER}/${id}`,
            {
                isViewMode: value,
            }
        );
        }
        const handleViewInvoiceSlip = (id,value)=>() => {
            
        navigateTo(
            `${privateRoutesPath.EDIT_INVOICE}/${id}`,
            {
                isViewMode: value,
            }
        );
        }
    
        const handleViewLead = (id,value)=>() => {
            openInNewTab(
                `${privateRoutesPath?.EDIT_LEAD}/${id}`
            );
        }
        const goBack = ()=>{
            
                goBackTo(`${privateRoutesPath?.CUSTOMER}`,searchEntity?.customer);
        }
        const customerLeadColumns = [
    {
                field : 'id',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_LEAD_ID'),
                flex : 1,
                minWidth : idWidth,
                editable : false,

                renderCell: (params) => {
                    const raw = params.row;

                    const item = {
                        rawId: raw.id,
                        rawItem: raw,
                        rawItem: {...raw,
                        latestNote : raw.followupNote,},
                        startDate: dateFormattingForShowing(raw.createdAt),
                        endDate: dateFormattingForShowing(raw.followupDate),   
                        rawStatus: raw.status,
                        systemLookup: raw.systemLookUpCodeStatus
                    };

                    return (
                        <Tooltip
                            title={
                                <ActionableDetailCard
                                    item={item}
                                    isLead={true}
                                    internationalise={internationalise}
                                    onClick={handleViewLead(raw.id, true)}
                                />
                            }
                            arrow
                            placement="top"
                            componentsProps={{
                                tooltip: {
                                    className: 'actionables-calendar__tooltip'
                                }
                            }}
                        >
                <span
                onClick={handleViewLead(raw.id, true)}
                className="customer-table-clickable-id"
                >
                {raw.id}
                </span>
                </Tooltip>
                );
                }
            },
            {
        field: 'ownerId',
        headerName: handleValidateCodevalue(internationalise, 'CUST_EDIT_SEARCH_OWNER'),
        flex: 1,
        minWidth : fullNameWidth,
        editable: false,
        valueGetter: ({ value }) => {
            if (!value) return '';
            const owner = ownerlist?.find(item => item?.id === value);
            return owner ? `${owner.firstName} ${owner.lastName}` : '';
        }
    },
            {
                field : 'createdAt',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_LEAD_CREATED_AT'),
                flex : 1,
                editable : false,
                minWidth : whocolumnWidth,
            },
            {field: 'totalValue',
                  headerName:  handleValidateCodevalue(internationalise,'LEAD_SEARCH_TOTAL_VALUE'),
                  flex: 1,
                  editable: false ,
                  minWidth: sellingPriceWidth,
                },
            {
                field : 'status',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_LEAD_STATUS'),
                flex : 1,
                editable : false,
                minWidth: statusChipWidth,
                renderCell: (params) => (
                    <StatusChip
                        isLead={true}
                        systemLookup={params?.row?.systemLookUpCodeStatus}
                        status={params.row.status}
                        internationalise={internationalise}
                    />
                )
            }
        ]
        
        const customerOrderColumns = [
            {
                field : 'id',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_ORD_ID'),
                flex : 1,
                editable : false,
                renderCell : ({id})=>(
                <span
                onClick={handleViewOrderSlip(id,true)}
                className="customer-table-clickable-id"
                >
                {id}
                </span>
                )
            },
            {
        field: 'ownerId',
        headerName: handleValidateCodevalue(internationalise, 'CUST_EDIT_SEARCH_OWNER'),
        flex: 1,
        editable: false,
        valueGetter: ({ value }) => {
            if (!value) return '';
            const owner = ownerlist?.find(item => item?.id === value);
            return owner ? `${owner.firstName} ${owner.lastName}` : '';
        }
    },
            {
                field : 'createdAt',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_ORD_CREATED_AT'),
                flex : 1,
                editable : false,
            },
            {
                field : 'totalOrderPrice',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_ORD_TOTALPRICE'),
                flex : 1,
                editable : false,
            },
            {
                field : 'status',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_ORD_STATUS'),
                flex : 1,
                editable : false,
                valueGetter : ({value}) => value ? handleValidateCodevalue(internationalise,value) : ""
            }
        ]
              
        const customerInvoiceColumns = [
            {
                field : 'id',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_INV_ID'),
                flex : 1,
                editable : false,
                renderCell : ({id})=>(
                <span
                onClick={handleViewInvoiceSlip(id,true)}
                className="customer-table-clickable-id"
                >
                {id}
                </span>
                )
            },
             {
        field: 'ownerId',
        headerName: handleValidateCodevalue(internationalise, 'CUST_EDIT_SEARCH_OWNER'),
        flex: 1,
        editable: false,
        valueGetter: ({ value }) => {
            if (!value) return '';
            const owner = ownerlist?.find(item => item?.id === value);
            return owner ? `${owner.firstName} ${owner.lastName}` : '';
        }
    },
            {
                field : 'createdAt',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_INV_CREATED_AT'),
                flex : 1,
                editable : false,
            },
            {
                field : 'totalPrice',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_INV_TOTALPRICE'),
                flex : 1,
                editable : false,
            },
            {
                field : 'status',
                headerName : handleValidateCodevalue(internationalise,'CUST_EDIT_INV_STATUS'),
                flex : 1,
                editable : false,
                valueGetter : ({value}) => value ? handleValidateCodevalue(internationalise,value) : ""
            }
        ]


    const handleChangeCustomer = (event) => {
        setCustomerdetails({
            ...customerDetail,
            [event.target.name]: event.target.value
        })
    }
const displayedLeads = useMemo(() => {
    const allLeads = customerDetail?.leadDtoList || [];

    if (!showOpenLeadsOnly) {
        return allLeads;
    }
    return allLeads.filter(lead => {
        const matchedStatus = leadStatusData?.find(
            item => item?.name === lead?.status
        );

        const isDealClosedOrCancelled =
            matchedStatus?.systemLookupCode?.name === LEAD_STATUS_DEAL_CLOSED ||
            matchedStatus?.systemLookupCode?.name === 'LEAD_STATUS_CANCELLED';

        return !isDealClosedOrCancelled;
    });

}, [customerDetail?.leadDtoList, leadStatusData, showOpenLeadsOnly]);

    useEffect(() => {
        if(customerid) {
            handleGetCustomerData();
        }
    },[customerid])


    const handleGetCustomerData = async() => {
        dispatch(requestShowLoader());
        const url = `${process.env.REACT_APP_BASE_URL}customers/${customerid}`;
        const responseData = await getRequestData(url);
        if(responseData?.data) {
            dispatch(requestHideLoader());
            const customerLeadResponse = responseData?.data?.leadDtoList.map(item=>{
                return {
                    ...item,
                    createdAt : dateFormatting(item?.createdAt)
                }
            })
            const customerSalesOrderResponse = responseData?.data?.salesOrderDtoList.map(item=>{
                return {
                    ...item,
                    createdAt : dateFormatting(item?.createdAt)
                }
            })
            const customerInvoiceResponse = responseData?.data?.invoiceDtoList.map(item=>{
                return {
                    ...item,
                    createdAt : dateFormatting(item?.createdAt)
                }
            })
            
    const filteredSource = customerSourceData?.find(item=> responseData?.data?.source === item?.name)
            const updatedData = {
            ...responseData.data,
            invoiceDtoList: customerInvoiceResponse,
            salesOrderDtoList: customerSalesOrderResponse,
            leadDtoList: customerLeadResponse,
            selectedSource : filteredSource
            };
            setCustomerdetails(updatedData);
            setInitialCustomerDetails(updatedData);
            await getCustomerProductDetails(customerid);

        }
        else {
            dispatch(requestHideLoader())
        }
    }

    const handleSaveCustomer = () => {
        
        const {errors,hasError} = validateFields(customerTextfieldsData, customerDetail);
        if(!hasError) {
              const reqpayload = formatAdditionalAttributesForPayload(
                        {
                            ...customerDetail,
                        },
                            [...ADDITIONAL_ATTRIBUTE_FIELDS,...CUSTOMIZABLE_FIELDS_CUSTOMER]
                        );
            dispatch(requestCreateCustomer(
                reqpayload,
                (createdCustomer) => {
                    enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_CREATED_SUCCESSFULLY"), { variant: 'success' });
                    dispatch(requestGetAllCustomers());
                    navigateTo(`${privateRoutesPath?.EDIT_CUSTOMER}/${createdCustomer?.id}`);
                },
                (error) => {
                    enqueueSnackbar(handleValidateCodevalue(internationalise, error?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
                }
            ));
        } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"), { variant: "error" });
            setRequiredValue(errors);
        }
    }

    const handleupdateCustomer = async(value = false) => {
        const { errors, hasError } = validateFields(customerTextfieldsData, customerDetail);
        if (!hasError) {
        if(JSON.stringify(customerDetail) == JSON.stringify(initialCustomerDetails)){
            if(value == true){
                goBack();
            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"), {variant: 'info'})
            }
        }
        else{
        dispatch(requestShowLoader());
        const reqpayload = formatAdditionalAttributesForPayload(
            {
                ...customerDetail,
            },
                [...ADDITIONAL_ATTRIBUTE_FIELDS,...CUSTOMIZABLE_FIELDS_CUSTOMER]
        );
        const url = `${process.env.REACT_APP_BASE_URL}customers/${customerid}`;
        const responseData = await updateRequestData(reqpayload, url);
        if(responseData?.status == 200) {
            await handleGetCustomerData();
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY"), {variant: 'success'})
            setIsAuditAccordionExpanded(false);
            dispatch(requestHideLoader());
            if(value == true){
                goBack();
            }
        }
        else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN") , {variant : 'error'});
            dispatch(requestHideLoader());
        }
    }
}
else{
    enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS") , {variant:"error"})
        setRequiredValue(errors)
        return
}
    }

    const handleChangeDocument = (event) => {

        const file = event.target.files[0];

        if(file) {
            setSelectedDocumentType({
                ...selectedDocumentType,
                [event.target.name]: file
            })

        } else {
            setSelectedDocumentType({
                ...selectedDocumentType,
                [event.target.name]: event.target.value
            })
        }
       
    }

    const handleUploadDocument = () => {

    }

    const handleAuditAccordionChange = auditAccordion.onAccordionChange;
const handleSelectCompany = (event,Owner,entity)=>{
if(entity === "Source"){
    setCustomerdetails({
        ...customerDetail,
        selectedSource : Owner,
        source : Owner?.name
    })
}
}

    
    // const handleOpenNotificationPopup = async()=>{
    //     setIsOpenNotificationDialog({
    //         ...isOpenNotificationDialog,
    //         selectedDetails : [customerDetail?.id],
    //         isOpen : true,
    //     });
    // }
    
    
    // const [isOpenNotificationDialog,setIsOpenNotificationDialog] = useState({
    //     selectedTemplate : null,
    //     isOpen : false,
    // })
const [customerproduct, setCustomerProduct] = useState([]);
const [selectedaddedproduct, setselectedaddedproduct] = useState([]);
const [selectedproduct, setSelectedproduct] = useState(null);
const [selectedproductData, setSelectedProductData] = useState(null);
const [productQuantity, setproductQuantity] = useState(null);
const [pricerange, setpricerange] = useState([0, 100000000]);
const [inputprice, setInputprice] = useState({
    pricefromInput: 0,
    pricetoInput: 100000000
});
const [tableData, setTableData] = useState([]);


const getCustomerProductDetails = async(customerId) => {
    const reqUrl = `${process.env.REACT_APP_BASE_URL}customerproducts/search?customerId=${customerId}`;
    const responseData = await getRequestData(reqUrl);
    if(responseData?.data) {
        const productdata = responseData?.data;
        const tableproductData = productdata.map(item => {
            return {
                ...item,
                unitOfMeasurement: item?.product?.unitOfMeasurement,
                id: item?.id, 
                sellingPrice: item?.sellingPrice,
                quantity: item?.productQuantity,
                grossprice: parseInt(item?.productQuantity || 0) * parseFloat(item?.sellingPrice || 0),
                priceAfterDiscount: (parseFloat(item?.sellingPrice || 0) - (parseFloat(item?.sellingPrice || 0) * parseFloat(item?.primaryDiscount || 0)) / 100) * parseFloat(item?.productQuantity || 0),
                unitDiscountAmount: parseFloat(item?.sellingPrice || 0) - (parseFloat(item?.sellingPrice || 0) - (parseFloat(item?.sellingPrice || 0) * parseFloat(item?.primaryDiscount || 0)) / 100),
            }
        })
        setCustomerProduct(tableproductData);
    }
}

const handleAddCustomerProduct = async() => {
    const reqProduct = selectedaddedproduct.map(item => {
        return {
            "customer": { "id": customerid }, 
            "productId": item?.id,
            "productQuantity": 1,
            "sellingPrice": item?.price,
            "primaryDiscount": item?.primaryDiscount,
            "sGst": item?.sgstRate,
            "cGst": item?.cgstRate,
            "surchargeRate": item?.surChangeRate 
        }
    })
    dispatch(requestShowLoader());
    const reqUrl = `${process.env.REACT_APP_BASE_URL}customerproducts/multiple`;
    const responseData = await createRequestData(reqProduct, reqUrl);
    if(responseData?.status == 200) {
        getCustomerProductDetails(customerid);
        setIsAuditAccordionExpanded(false);
        enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_ADDED_SUCCESSFULLY'), { variant: 'success' });
        setselectedaddedproduct([]);
        dispatch(requestHideLoader());
        return true;
    } else {
        enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_PLEASE_TRY_AGAIN'), {variant: 'error'});
        dispatch(requestHideLoader());
        return false;
    }
}

const handleUpdateCustomerProduct = async (reqObj) => {
    const reqPayload = {
        ...reqObj,
        "customer": { "id": customerid },
        "productId": reqObj?.productId,
        "productQuantity": parseFloat(reqObj?.quantity || reqObj?.productQuantity),
        "sellingPrice": reqObj?.price || reqObj?.sellingPrice,
        "primaryDiscount": reqObj?.primaryDiscount,
        "sGst": reqObj?.sGst || reqObj?.sgst,
        "cGst": reqObj?.cGst || reqObj?.cgst,
        "surchargeRate": reqObj?.surchargeRate || reqObj?.surCharge
    }
    dispatch(requestShowLoader());
    const url = `${process.env.REACT_APP_BASE_URL}customerproducts/${reqObj?.id}`;
    const responseData = await updateRequestData(reqPayload, url);
    if(responseData?.status == 200) {
        await getCustomerProductDetails(customerid);
        setIsAuditAccordionExpanded(false);
        enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_UPDATED_SUCCESSFULLY'), {variant: 'success'});
        dispatch(requestHideLoader());
    } else {
        dispatch(requestHideLoader()); 
        enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_PLEASE_TRY_AGAIN'), {variant: 'error'});
    }
}


const handleSelectMultiproduct = (event, productData, reason) => {
    if (productData.find(option => option.value === "select-all")) {
        setselectedaddedproduct([...selectedaddedproduct, ...filterdOptionlist]);
    } else {
        setselectedaddedproduct(productData);
    } 
}

const handleFilterOption = (options, params) => {
    const filter = createFilterOptions();
    filterdOptionlist = filter(options, params);
    return [{ name: 'Select All', price: "", value: "select-all" }, ...filterdOptionlist];
}

const handleChangeQuantity = (e) => {
    setproductQuantity(e.target.value)
}

const handlechangeInputprice = (event) => {
    setInputprice({
        ...inputprice,
        [event.target.name]: event.target.value
    })
}

const handleChangerange = (event, newValue) => {
    setpricerange(newValue);
};

const {subTotal, totalGst, discountAmount, cGstAmount, sGstAmount, surchargeAmount, priceAfterDiscount, finalPrice} = 
    customerproduct.reduce(
        (acc, item) => {
            const sub = Number(item.subTotal || 0);
            const discount = Number(item.discountAmount || 0);
            const cgst = Number(item.cGstAmount || 0);
            const sgst = Number(item.sGstAmount || 0);
            const surcharge = Number(item.surchargeAmount || 0);

            acc.subTotal += sub;
            acc.discountAmount += discount;
            acc.cGstAmount += cgst;
            acc.sGstAmount += sgst;
            acc.surchargeAmount += surcharge;

            acc.priceAfterDiscount = acc.subTotal - acc.discountAmount;
            acc.totalGst = acc.cGstAmount + acc.sGstAmount;
            const totalTax = acc.cGstAmount + acc.sGstAmount + acc.surchargeAmount;
            acc.finalPrice = acc.priceAfterDiscount + totalTax;

            return acc;
        },
        {
            totalGst: 0,
            subTotal: 0,
            discountAmount: 0,
            cGstAmount: 0,
            sGstAmount: 0,
            surchargeAmount: 0,
            priceAfterDiscount: 0,
            finalPrice: 0,
        }
    );
        const handleCopyCreateLead = () => {
            
            const copyLeadRequiredData = {
               ...customerDetail,
            }
            
                navigateTo(`${privateRoutesPath?.CREATE_LEAD}`,{
                    currentLeadDetail: copyLeadRequiredData,
                });
    }

    const handleCreateLeadFromRecommendations = (selectedRecIds) => {
        
                navigateTo(`${privateRoutesPath?.CREATE_LEAD}`,{
                    currentLeadDetail: {
                        ...customerDetail,
                        followupNote : RECOMMENED_PRODUCTS_FOLLOWUP_NOTE
                    },
                    selectedProductIds: selectedRecIds,
                });
    }


const handleAddRecommendedProduct = async (selectedRecommendations) => {
    // selectedRecommendations contains recommendation objects
    const selectedSet = new Set(selectedRecommendations)
    const selectedProducts = activeProducts.filter(product =>
        selectedSet.has(product.id)
    );

    const reqProduct = selectedProducts.map(item => ({
        customer: { id: customerid },
        productId: item.id,
        productQuantity: 1,
        sellingPrice: item.price,
        primaryDiscount: item.primaryDiscount,
        sGst: item.sgstRate,
        cGst: item.cgstRate,
        surchargeRate: item.surChangeRate
    }));

    dispatch(requestShowLoader());

    const response = await createRequestData(
        reqProduct,
        `${process.env.REACT_APP_BASE_URL}customerproducts/multiple`
    );

    dispatch(requestHideLoader());

    if (response?.status === 200) {
        getCustomerProductDetails(customerid);
        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                "COMMON_ADDED_SUCCESSFULLY"
            ),
            { variant: "success" }
        );
    }
};

    const customerTaskColumns = [
    {
        field: 'id',
        headerName: handleValidateCodevalue(internationalise, 'CUST_EDIT_TASK_ID'),
        flex: 1,
        editable: false,
        renderCell: (params) => {
        const raw = params.row;
        // Build the same shape ActionableDetailCard expects
        const item = {
            rawId: raw.id,
            rawItem: {...raw,
            latestNote : raw.latestActivityNote,},
            startDate: dateFormattingForShowing(raw.createdAt),
            endDate: dateFormattingForShowing(raw.nextFollowupDate),     // adjust field name to match your row
            rawStatus: raw.status,
            systemLookup: raw.systemLookUpCodeStatus
        };

        return (
            <Tooltip
                title={
                    <ActionableDetailCard
                        item={item}
                        isLead={false}
                        internationalise={internationalise}
                         onClick={handleViewTask(raw.id, true)} 
                    />
                }
                arrow
                placement="top"
                componentsProps={{
                    tooltip: { className: 'actionables-calendar__tooltip' }
                }}
            >
                <span
                    onClick={handleViewTask(raw.id, true)}
                    className="customer-table-clickable-id"
                >
                    {raw.id}
                </span>
            </Tooltip>
        );
    }
},
    {
        field: 'ownerId',
        headerName: handleValidateCodevalue(internationalise, 'CUST_EDIT_SEARCH_OWNER'),
        flex: 1,
        editable: false,
        valueGetter: ({ value }) => {
            if (!value) return '';
            const owner = ownerlist?.find(item => item?.id === value);
            return owner ? `${owner.firstName} ${owner.lastName}` : '';
        }
    },
    {
        field: 'createdAt',
        headerName: handleValidateCodevalue(internationalise, 'CUST_EDIT_TASK_CREATED_AT'),
        flex: 1,
        editable: false,
        valueGetter: ({ value }) => value ? moment(value).format('MM/DD/YYYY') : ""
    },
    {
        field: 'secondaryType',
        headerName: handleValidateCodevalue(internationalise, 'TASK_SECONDARY_TYPE'),
        flex: 1,
        editable: false,
        valueGetter: ({ value }) => value ? handleValidateCodevalue(internationalise, value) : ""

    },
    {
        field: 'status',
        headerName: handleValidateCodevalue(internationalise, 'CUST_EDIT_TASK_STATUS'),
        flex: 1,
        minWidth: statusChipWidth,
        editable: false,
        renderCell: (params) => (
            <StatusChip
                isLead={false}
                systemLookup={params?.row?.systemLookUpCodeStatus}
                status={params.row.status}
                internationalise={internationalise}
            />
        )
    }
];

const taskStatusData = useSelector(state => state?.lookup?.lookupData)
    ?.find((item) => item?.name == TASK_STATUS)?.codes
    ?.filter(item => item?.status == ACTIVE_STATUS)
    ?.sort((a, b) => a?.sequence - b?.sequence);
const [showOpenTasksOnly, setShowOpenTasksOnly] = useState(true);

const handleToggleOpenTasks = useCallback((event) => {
    setShowOpenTasksOnly(event.target.checked);
}, []);

const displayedTasks = useMemo(() => {
    const allTasks = customerDetail?.taskDtoList || [];

    if (!showOpenTasksOnly) {
        return allTasks;
    }

    return allTasks.filter(task => {
        const matchedStatus = taskStatusData?.find(
            item => item?.name === task?.status
        );

        const isClosedOrCancelled =
            matchedStatus?.systemLookupCode?.name === TASK_STATUS_CLOSED ||
            matchedStatus?.systemLookupCode?.name === TASK_STATUS_CANCELLED;

        return !isClosedOrCancelled;
    });

}, [customerDetail?.taskDtoList, taskStatusData, showOpenTasksOnly]);


const handleCopyCreateTask = () => {
    const copyTaskRequiredData = {
        ...customerDetail,
    };
    navigateTo(`${privateRoutesPath?.TASKS_CREATE}`, {
        currentTaskDetail: copyTaskRequiredData,
    });
};

const handleViewTask = (id, isView) => () => {
    openInNewTab(
        `${privateRoutesPath?.EDIT_TASK}/${id}`
    );
};

const configLabels = STATIC_ENTITY_CONFIG?.CUSTOMER

const customerFormContent = (
    <>
        <StyledGridContainer>
        {customerid &&
          <TextFiledWithLabel 
            name="customerId"
            id="customerId"
            disabled={true}
            value={customerid}
            label={handleValidateCodevalue(internationalise,configLabels?.customerId?.label)}
        />}
           <SelectBoxWithLabel
            disabled = {isViewMode || !customerid}
            required={true}
            isStatic={false}
            ownerdropdown= {false}
            name= "status"
            error={customerDetail?.status ? false : requiredValue?.status}
            value= {customerDetail?.status ? customerDetail?.status : ''}
            optionMenuItem={customerStatusData}
            label={handleValidateCodevalue(internationalise,configLabels?.status?.label)}
            handleOnChange={handleChangeCustomer}
        />

            <CustomizableFields
                isViewMode = {isViewMode}
                CUSTOMIZABLE_FIELDS={["title"]}
                useWrapper={false}
                showHeader = {false}
                entity = "CUSTOMER"
                config={customerTextfieldsData}
                values={customerDetail}
                setValues = {setCustomerdetails}
                handleOnChange={handleChangeCustomer}
                errors={requiredValue}
            />

        {customerTextfieldsData?.firstName?.visibility &&
        <TextFiledWithLabel 
            disabled = {isViewMode}
            name="firstName"
            inputRef={inputRef}
            error={customerDetail && customerDetail.firstName ? false : requiredValue?.firstName}
            id="lead" 
            required={customerTextfieldsData?.firstName?.mandatory}
            label={handleValidateCodevalue(internationalise,configLabels?.firstName?.label)}
            handleOnChange={handleChangeCustomer}
            value={customerDetail?.firstName}
        />
        }
        {customerTextfieldsData?.lastName?.visibility &&
        <TextFiledWithLabel 
            disabled = {isViewMode}
            name="lastName"
            inputRef={inputRef}
            error={customerDetail && customerDetail.lastName ? false : requiredValue?.lastName}
            id="lead" 
            required={customerTextfieldsData?.lastName?.mandatory}
            label={handleValidateCodevalue(internationalise,configLabels?.lastName?.label)}
            handleOnChange={handleChangeCustomer}
            value={customerDetail?.lastName}
        />
        }
        {customerTextfieldsData?.externalNumber?.visibility &&
        <TextFiledWithLabel 
            disabled = {isViewMode}
            name="externalNumber"
            inputRef={inputRef}
            error={customerDetail?.externalNumber ? false : requiredValue?.externalNumber}
            id="lead" 
            required={customerTextfieldsData?.externalNumber?.mandatory}
            label={handleValidateCodevalue(internationalise,configLabels?.externalNumber?.label)}
            handleOnChange={handleChangeCustomer}
            value={customerDetail?.externalNumber}
            />
            }
            
        {customerTextfieldsData?.selectedSource?.visibility && 
        <AutoCompleteComponent
            isLookup = {true}
            optionSet = {customerSourceData}
            value={customerDetail?.selectedSource || null}
            disabled={isViewMode}
            error={customerDetail && customerDetail.selectedSource ? false : requiredValue?.selectedSource}
            name = "source"
            required={customerTextfieldsData?.selectedSource?.mandatory}
            placeholder={handleValidateCodevalue(internationalise,configLabels?.selectedSource?.label)}
            label={handleValidateCodevalue(internationalise,configLabels?.selectedSource?.label)}       
            onChange={(e, val) => handleSelectCompany(e, val, "Source")}
        />
        }

        {customerTextfieldsData?.occupation?.visibility &&
        <TextFiledWithLabel 
            disabled = {isViewMode}
            id="occupation" 
            error={customerDetail && customerDetail.occupation ? false : requiredValue?.occupation}
            name="occupation"
            required={customerTextfieldsData?.occupation?.mandatory}
            value={customerDetail?.occupation}
            handleOnChange={handleChangeCustomer}
            label={handleValidateCodevalue(internationalise,configLabels?.occupation?.label)}
        />
        }
 
        {customerid &&
  <TextFiledWithLabel 
    label={handleValidateCodevalue(internationalise,configLabels?.totalValue?.label)}
    value={finalPrice ? Number(finalPrice).toLocaleString('en', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) : '0.00'}
    disabled
  />
}

            <CustomizableFields
                isViewMode = {isViewMode}
                CUSTOMIZABLE_FIELDS={
                CUSTOMIZABLE_FIELDS_CUSTOMER.filter(
                field => field !== "title"
                    )
                }
                useWrapper={false}
                showHeader = {false}
                entity = "CUSTOMER"
                config={customerTextfieldsData}
                values={customerDetail}
                setValues = {setCustomerdetails}
                handleOnChange={handleChangeCustomer}
                errors={requiredValue}
            />
        </StyledGridContainer>
            <CustomizableFields
                isViewMode = {isViewMode}
                CUSTOMIZABLE_FIELDS={ADDITIONAL_ATTRIBUTE_FIELDS}
                entity = "CUSTOMER"
                config={customerTextfieldsData}
                values={customerDetail}
                setValues = {setCustomerdetails}
                handleOnChange={handleChangeCustomer}
                errors={requiredValue}
            />
    {customerid &&
    <WhoColumnTextfieds
    entityDetails={customerDetail}
    />
    }
        
    <CommonComm
    required= {true}
    isDetailPage = {true}
    isViewMode={isViewMode}
    requiredValue={requiredValue}
    handleOnChange={handleChangeCustomer}
    state = {customerDetail}
    showAlternateEmail={true}
    />
    <AddressFields
    disabled = {isViewMode}
    entityDetails={customerDetail}
    setEntityDetails={setCustomerdetails}
    onChange={handleChangeCustomer}
    />
    <CommonPoc
    isViewMode = {isViewMode}
    isDetailPage={true}
    requiredValue={false}
    handleOnChange={handleChangeCustomer}
    state={customerDetail}
    />
    
        <EntityNote
        isViewMode = {isViewMode}
        entityDetails = {customerDetail} 
        onChange = {handleChangeCustomer}
        headingLabel = {handleValidateCodevalue(internationalise,"COMMON_SPECIAL_NOTE")}
                            
        />
    </>
);

    return (
            <BiztantuLoader open={isLoadingProgress} isChildren={true}>
             <Box className='globalBox'> 
                    {/* <Typography variant='h6'>
                        {customerid ? handleValidateCodevalue(internationalise,'CUST_EDIT_TITLE_UPDATE') : handleValidateCodevalue(internationalise,'CUST_EDIT_TITLE_CREATE')}
                    </Typography> */}
                    {customerid ? (
                        <LeadAccordion
                            label={`${handleValidateCodevalue(internationalise,'CUST_EDIT_CUSTOMER_DETAILS')} - ${customerid}`}
                            defaultOpen={true}
                        >
                        {(!isViewMode && customerid) &&
                        <Box className = "mt-15 mb-10">
                            <Button className='edit-primary' variant="outlined" onClick={customerid ? handleupdateCustomer : handleSaveCustomer}>{handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                            </Button>
                            <Button className = "edit-primary btn-space" variant="outlined" onClick={()=>handleupdateCustomer(true)}>{`${handleValidateCodevalue(internationalise,'COMMON_SAVE_AND_EXIT')}`}
                            </Button>
                        </Box>}
                            {customerFormContent}
                        </LeadAccordion>
                    ) : (
                        <>
                            <StyledSubHeader>
                                {handleValidateCodevalue(internationalise,'CUST_EDIT_CUSTOMER_DETAILS')}
                            </StyledSubHeader>
                            {customerFormContent}
                        </>
                    )}
                   {customerid && 
    <LeadProduct
        isViewMode={isViewMode}
        isEdit={true}
        isCustomerProduct={true}
        customerId={customerid}
        showRecommendations={true}
        getProductDetails={() => getCustomerProductDetails(customerid)}
        data={customerproduct}
        selectedproductData={selectedproductData}
        selectedproduct={selectedproduct}
        selectedaddedproduct={selectedaddedproduct}
        productQuantity={productQuantity}
        handleChangeQuantity={handleChangeQuantity}
        getDataGridData={(data) => setTableData(data)}
        handleAddLeadProduct={handleAddCustomerProduct}
        handleUpdateLeadproduct={handleUpdateCustomerProduct}
        handleSelectMultiproduct={handleSelectMultiproduct}
        handleFilterOption={handleFilterOption}
        inputprice={inputprice}
        handlechangeInputprice={handlechangeInputprice}
        handleChanange={handleChangerange}
        pricerange={pricerange}
        accordionLabel={handleValidateCodevalue(internationalise, 'CUSTOMER_PRODUCTS')}
        recommendationDialogTitle = {handleValidateCodevalue(internationalise, 'CUST_PROD_RECC_TITLE')}
        onRecommendationSave={handleCreateLeadFromRecommendations} 
        onRecommendationSecondaryAction = {handleAddRecommendedProduct}
        primaryRecommendButtonLabel={handleValidateCodevalue(internationalise,"LEAD_CREATE")}   
        recommendationButtonLabel={handleValidateCodevalue(internationalise, 'CUST_PROD_RECC')}
        fetchRecommendationsUrl={`${process.env.REACT_APP_BASE_URL}customers/${customerid}/recommendations`}
        />
}
  {customerid && (
    <Box>
     <LeadAccordion 
    label={handleValidateCodevalue(internationalise, 'CUST_EDIT_TASK_DATA')}
>
    <Stack padding="24px 24px 24px 0px" alignItems="center" display={"flex"} gap={2} flexDirection={"row"}>
        {!isViewMode &&
        <Tooltip title={handleValidateCodevalue(internationalise, "CREATE_FOR_CUSTOMER")}>
            <Button
                className='secondry-edit-btn' 
                variant="outlined" 
                onClick={handleCopyCreateTask}
            >
                {handleValidateCodevalue(internationalise, "CUST_CREATE_NEW_TASK")}
            </Button>
        </Tooltip>
        }

        <FormControlLabel
            control={
                <Switch
                    checked={showOpenTasksOnly}
                    onChange={handleToggleOpenTasks}
                    name="showOpenTasks"
                    color="primary"
                />
            }
            label={handleValidateCodevalue(internationalise, "COMMON_SHOW_ONLY_ACTIVE_TASKS")}
        />
    </Stack>

    <DataGridTable
        columns={customerTaskColumns}
        dataGridData={displayedTasks}
        isRequiredToolBar={false}
        isCheckboxReq={false}
        isInvoiceproduct={true}
        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
        height={CHILD_DATAGRIDTABLE_HEIGHT}
    />
</LeadAccordion>

        </Box>
                    )}
                 
                {customerid &&
                <Box>
                   <LeadAccordion 
    label={handleValidateCodevalue(internationalise,'CUST_EDIT_LEAD_DATA')}
>
    <Stack padding="24px 24px 24px 0px" alignItems="center" display={"flex"} gap={2} flexDirection={"row"}>
        {!isViewMode &&
        <Tooltip title={handleValidateCodevalue(internationalise,"CREATE_FOR_CUSTOMER")}>
            <Button 
                className='secondry-edit-btn' 
                variant="outlined" 
                onClick={handleCopyCreateLead}
            >
                {handleValidateCodevalue(internationalise,"CUST_CREATE_NEW_LEAD")}
            </Button>
        </Tooltip>
            }
        
        <FormControlLabel
            control={
                <Switch
                    checked={showOpenLeadsOnly}
                    onChange={handleToggleOpenLeads}
                    name="showOpenLeads"
                    color="primary"
                />
            }
            label={handleValidateCodevalue(internationalise, "COMMON_SHOW_ONLY_ACTIVE_LEADS")}
        />
    </Stack>
    
    <DataGridTable
        columns={customerLeadColumns}
        dataGridData={displayedLeads}
        isRequiredToolBar={false}
        isCheckboxReq={false}
        isInvoiceproduct={true}
        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
        height={CHILD_DATAGRIDTABLE_HEIGHT}
    />
</LeadAccordion>
            {specificRolePermission?.isOrderView &&
                <LeadAccordion
                    label = {handleValidateCodevalue(internationalise,'CUST_EDIT_ORD_DATA')}
                    
                >

                <DataGridTable
                    columns ={customerOrderColumns}
                    rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                    height={CHILD_DATAGRIDTABLE_HEIGHT}
                    dataGridData = {customerDetail?.salesOrderDtoList}
                    isRequiredToolBar = {false}
                    isCheckboxReq = {false}
                    isInvoiceproduct = {true}
                />
                </LeadAccordion>
            }
            {specificRolePermission?.isInvoiceView &&
                <LeadAccordion
                    label={handleValidateCodevalue(internationalise,'CUST_EDIT_INV_DATA')}
                >
                <DataGridTable
                    columns ={customerInvoiceColumns}
                    dataGridData = {customerDetail?.invoiceDtoList}
                    isRequiredToolBar = {false}
                    isCheckboxReq = {false}
                    isInvoiceproduct = {true}
                    rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                    height={CHILD_DATAGRIDTABLE_HEIGHT}
                />
                </LeadAccordion>
                }
                </Box>
                    }
                    
                  

                {customerid && <DocumentManagement
                entityType='customerId'
                url = {`${process.env.REACT_APP_BASE_URL}customerDocument`}
                docType={docType}
                isViewMode={isViewMode}
                clientId = {customerid}
                onSuccess={() => setIsAuditAccordionExpanded(false)}
                />
                }

                {(specificRolePermission?.isAuditView && customerid) && <div>
                    <LeadAccordion
                        label={handleValidateCodevalue(internationalise,'COMMON_AUDIT_LOGS')}
                        {...auditAccordion.accordionProps}
                    >
                        <AuditLogs
                            label = ""
                            isSearchRequired = {false}
                            entityDetails = {{
                                entityId: customerid,
                                entity: "CUSTOMER_SIDEBAR_MENU"
                            }}
                            module="Customer"
                        />
                    </LeadAccordion>
                    
                </div>}
               
                </Box>
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
                    <Typography variant='h6'>
                            {customerid ? `${handleValidateCodevalue(internationalise, 'CUST_EDIT_TITLE_EDIT')} - ${customerid}` : handleValidateCodevalue(internationalise, 'CUST_EDIT_TITLE_CREATE')}
                    </Typography>
                
                    <Button className='edit-primary btn-space' variant="outlined" onClick={goBack}>{handleValidateCodevalue(internationalise,'COMMON_BACK')} </Button>
                    {/* {(specificRolePermission?.isCustomerManage && isViewMode) && <Button className='edit-primary' variant="outlined" onClick={()=>setIsViewMode(!isViewMode)}>{handleValidateCodevalue(internationalise,"COMMON_EDIT")}</Button>}            */}
                    {(!isViewMode && !customerid) &&
                    <Button className='edit-primary' variant="outlined" onClick={customerid ? handleupdateCustomer : handleSaveCustomer}>{handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                    </Button>}
                </Stack>
                {(customerid && specificRolePermission?.isCustomerManage) &&
                <Stack direction="row" spacing={1}>
                    {isDemoMode && (
                      <Tooltip title="Support Assistant">
                        <Button
                          className='secondry-edit-btn btn-space'
                          variant="outlined"
                          onClick={() => setIsOpenSupportChatDialog(true)}
                        >
                          Support Assistant (AI)
                        </Button>
                      </Tooltip>
                    )}
                </Stack>
                }
            </CreateLeadFooter>
                {/* {
                    (isOpenNotificationDialog?.isOpen) && (
                        <SendNotification
                            open={isOpenNotificationDialog?.isOpen}
                            title= {handleValidateCodevalue(internationalise,"COMMON_NOTIFY_CUSTOMER")}
                            setIsOpenNotificationDialog={setIsOpenNotificationDialog}
                            selectedDetails={isOpenNotificationDialog?.selectedDetails}
                            type = {"Customer"}        
                        />
                    )
                } */}
                {isOpenSupportChatDialog && (
                  <SupportChatDialog
                    open={isOpenSupportChatDialog}
                    handleClose={() => setIsOpenSupportChatDialog(false)}
                  />
                )}
        </BiztantuLoader >

    )
}
export default CreateMerchant;

